'use client';
import { motion, useReducedMotion, useScroll, useSpring, useTransform, useVelocity } from 'framer-motion';

// Titre géant : les lignes glissent en sens opposé au scroll et s'étirent selon la vitesse.
export default function KineticTitle({ lines, className = '' }: { lines: string[]; className?: string }) {
    const reduce = useReducedMotion();
    const { scrollY } = useScroll();
    const velocity = useSpring(useVelocity(scrollY), { stiffness: 400, damping: 60 });
    const skew = useTransform(velocity, [-2500, 2500], [10, -10], { clamp: true });
    const stretch = useTransform(velocity, [-2500, 0, 2500], [1.18, 1, 1.18], { clamp: true });
    const left = useTransform(scrollY, [0, 900], ['0%', '-12%']);
    const right = useTransform(scrollY, [0, 900], ['0%', '12%']);

    return (
        <h1 className={`font-(family-name:--pf-serif) leading-[0.86] tracking-[-0.03em] ${className}`}>
            {/* Chaque ligne est masquée pour l'entrée : pb laisse la place aux jambages (g, p), -mb garde l'interlignage serré */}
            {lines.map((line, i) => (
                <span key={line} className="-mb-[0.16em] block overflow-hidden pb-[0.22em]">
                    <motion.span
                        className="block origin-bottom whitespace-nowrap will-change-transform"
                        initial={reduce ? false : { y: '110%' }}
                        animate={{ y: '0%' }}
                        transition={{ duration: 1.1, delay: 0.15 + i * 0.12, ease: [0.16, 1, 0.3, 1] }}
                        style={reduce ? undefined : { x: i % 2 ? right : left, skewX: skew, scaleY: stretch }}
                    >
                        {line}
                    </motion.span>
                </span>
            ))}
        </h1>
    );
}
